<label class="header">
    {{ question.label }}
</label>

<div
    class="educational-slide"
    *ngIf="question.educationalSlide"
    [innerHTML]="question.educationalSlide"
></div>

<nz-radio-group
    *ngIf="question.type === 'polar_check'"
    style="padding-left: 1rem"
    [name]="question.field"
    [ngModel]="data.isNo"
    [ngModelOptions]="{ standalone: true }"
    disabled
>
    <label nz-radio [nzValue]="false">Yes</label>
    <label nz-radio [nzValue]="true">No</label>
</nz-radio-group>

<div *ngIf="!data.isNo" class="container">
    <consultation-answer
        [field]="question.field"
        [answer]="question.answer"
        [data]="data"
        [answers]="answers"
        [brand]="brand"
        [question]="question"
        [allAnswers]="allAnswers"
    ></consultation-answer>

    <input
        *ngIf="question.type === 'select'"
        type="text"
        class="hidden"
        [name]="'validAnswer_' + question.field"
        [ngModel]="validateCheck"
        required
    />
</div>
